import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=497b316c&scoped=true&"
import script from "./Market.vue?vue&type=script&lang=js&"
export * from "./Market.vue?vue&type=script&lang=js&"
import style0 from "./Market.vue?vue&type=style&index=0&id=497b316c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b316c",
  null
  
)

export default component.exports